export const deleteWhiteSpaces = (value) => {
    if (value && value.length > 0)
        return value.trim().replace(/\s+/g, " ");
    return value;
};

export const encodeString = (value) => {
    if (value && value.length > 0)
    // eslint-disable-next-line no-useless-escape
        return value.replace(/[<>\/&\\]/gim, (i) => ( "&#" + i.charCodeAt(0) + ";"));
    return value;
};

export const contains = (item, key, ignoreMissedItem = true) => {
    if (key) {
        key = deleteWhiteSpaces(key).toLowerCase();
    }
    return ignoreMissedItem && !item || !key || item.toLowerCase().indexOf(key) > -1;
};

export const equals = (string1, string2, caseSensitive = false) => {
    if (!string1 || !string2 || caseSensitive)
        return string1 == string2;

    return string1.toLowerCase() == string2.toLowerCase();
};

export const guid = () => {
    function s4 () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
        s4() + "-" + s4() + s4() + s4();
};
